export default __webpack_public_path__ + "static/media/doctor_consultation.aa787a90.svg";